import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterGuard } from './authGuard'
import { useLoadingRouteStore } from '@/stores/loadingRoute'
import { responsiveComponent } from './responsiveComponent'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_HISTORY_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/desktop/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: () => import('@/views/desktop/ResetPasswordView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/desktop/HomeView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/entries-list',
      name: 'entries-list',
      component: responsiveComponent(
        () => import('@/views/desktop/EntriesListView.vue'),
        () => import('@/views/mobile/EntriesListView.vue'),
      ),
      meta: { requiresAuth: true },
    },
    {
      path: '/user-management',
      name: 'user-management',
      component: () => import('@/views/desktop/UserManagementView.vue'),
      meta: { requiresAuth: true, requiredRoles: ['Projektadmin'] },
    },
    {
      path: '/designer',
      name: 'designer',
      component: () => import('@/views/desktop/DesignerView.vue'),
      meta: { requiresAuth: true, requiredRoles: ['Projektadmin'] },
    },
    {
      path: '/user-settings',
      name: 'user-settings',
      component: () => import('@/views/desktop/UserSettingsView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/entry/:id?',
      name: 'entry',
      component: responsiveComponent(
        () => import('@/views/desktop/EntryView.vue'),
        () => import('@/views/mobile/EntryView.vue'),
      ),
      meta: { requiresAuth: true },
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: () => import('@/views/desktop/UnauthorizedView.vue'),
      meta: { public: true },
    },
  ],
})

// Setup router guard
setupRouterGuard(router)

// Show loading spinner when navigating between routes
router.beforeEach(() => {
  const loading = useLoadingRouteStore()
  loading.show()
})

router.afterEach(() => {
  const loading = useLoadingRouteStore()
  loading.hide()
})

export default router
